// extracted by mini-css-extract-plugin
export default {"list":"styles_list__hqYaJ","item":"styles_item__JqEW9","icon":"styles_icon__gzujf","text":"styles_text__fE6Eb"};